(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-making-of"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lx-making__slider-wrap').forEach((wrap) => {
    const slider = wrap.querySelector('.lx-making__slider');
    const slides = Array.from(slider.querySelectorAll('.lx-making__image'));
    const dotsWrap = wrap.parentElement.querySelector('.lx-making__dots');
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.lx-making__dot')) : [];

    const goTo = (index) => {
      const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = slides.indexOf(entry.target);
            dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
          }
        });
      },
      { root: slider, threshold: 0.6 }
    );
    slides.forEach((slide) => observer.observe(slide));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function getModal() {
      return document.getElementById('lx-gallery-modal');
    }

    function setActive(index) {
      var modal = getModal();
      if (!modal) return;
      var slides = modal.querySelectorAll('[data-gallery-slide]');
      var total = slides.length;
      if (total === 0) return;
      var normalized = ((index % total) + total) % total;
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', Number(slide.dataset.gallerySlide) === normalized);
        slide.classList.remove('is-zoomed');
      });
      modal.dataset.currentIndex = normalized;
      var counter = modal.querySelector('[data-gallery-modal-current]');
      if (counter) counter.textContent = normalized + 1;
    }

    function openModal(index) {
      var modal = getModal();
      if (!modal) return;
      setActive(index);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lx-gallery-modal-lock');
    }

    function closeModal() {
      var modal = getModal();
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lx-gallery-modal-lock');
      modal.querySelectorAll('.lx-gallery-modal__slide.is-zoomed').forEach(function (slide) {
        slide.classList.remove('is-zoomed');
      });
    }

    function toggleZoom(slide, clientX, clientY) {
      var img = slide.querySelector('img');
      if (!img) return;
      if (slide.classList.contains('is-zoomed')) {
        slide.classList.remove('is-zoomed');
        return;
      }
      var rect = img.getBoundingClientRect();
      var originX = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      var originY = Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100));
      img.style.transformOrigin = originX + '% ' + originY + '%';
      slide.classList.add('is-zoomed');
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-gallery-modal-trigger]');
      if (trigger) {
        e.preventDefault();
        openModal(Number(trigger.dataset.galleryIndex || 0));
        return;
      }
      if (e.target.closest('[data-gallery-modal-close]')) {
        closeModal();
        return;
      }
      var modal = getModal();
      if (!modal) return;
      if (e.target.closest('[data-gallery-modal-next]')) {
        setActive(Number(modal.dataset.currentIndex || 0) + 1);
        return;
      }
      if (e.target.closest('[data-gallery-modal-prev]')) {
        setActive(Number(modal.dataset.currentIndex || 0) - 1);
        return;
      }
      var slide = e.target.closest('.lx-gallery-modal__slide');
      if (slide && e.target.tagName === 'IMG' && modal.classList.contains('is-open') && !isTouchInteraction) {
        toggleZoom(slide, e.clientX, e.clientY);
      }
    });

    document.addEventListener('keydown', function (e) {
      var modal = getModal();
      if (!modal || !modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') setActive(Number(modal.dataset.currentIndex || 0) + 1);
      if (e.key === 'ArrowLeft') setActive(Number(modal.dataset.currentIndex || 0) - 1);
    });

    var touchStartX = 0;
    var touchStartY = 0;
    var isTouchInteraction = false;
    var lastTapTime = 0;
    var lastTapSlide = null;

    document.addEventListener('touchstart', function (e) {
      var modal = getModal();
      if (!modal || !modal.classList.contains('is-open')) return;
      isTouchInteraction = true;
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      var modal = getModal();
      if (!modal || !modal.classList.contains('is-open')) return;
      var touch = e.changedTouches[0];
      var deltaX = touch.screenX - touchStartX;
      var deltaY = touch.screenY - touchStartY;

      if (Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) {
        var slide = e.target.closest('.lx-gallery-modal__slide');
        if (slide && e.target.tagName === 'IMG') {
          var now = Date.now();
          if (now - lastTapTime < 350 && lastTapSlide === slide) {
            toggleZoom(slide, touch.clientX, touch.clientY);
            lastTapTime = 0;
            lastTapSlide = null;
          } else {
            lastTapTime = now;
            lastTapSlide = slide;
          }
        }
      } else if (
        Math.abs(deltaX) >= 40 &&
        Math.abs(deltaX) >= Math.abs(deltaY) &&
        !modal.querySelector('.lx-gallery-modal__slide.is-zoomed')
      ) {
        if (deltaX < 0) {
          setActive(Number(modal.dataset.currentIndex || 0) + 1);
        } else {
          setActive(Number(modal.dataset.currentIndex || 0) - 1);
        }
      }

      setTimeout(function () {
        isTouchInteraction = false;
      }, 400);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
